// Dev
export const marketplace = {
    dev: {
        contract: '0x985EAd24c8adEc73dCe6e502aA0Eeb880D36cfE2'
    },
    prod: {
        contract: '0x6432D6C17D8768435d5602A873F4a4E71a9F38b4'
    }
}